// COMPONENTS
import ContainedButton from "src/components/common/ContainedButton";
import { ButtonText } from "../styles/Trade.styles";

interface TradeSubmitButtonProps {
  text: string;
  disabled: boolean;
  onClick: () => void;
  color?: "salmon" | "navy" | "neutral";
  id?: string;
  marginTop?: string;
}

export const TradeSubmitButton = ({
  text,
  disabled,
  onClick,
  color = "salmon",
  id = "submit-button",
  marginTop = "24px",
}: TradeSubmitButtonProps): JSX.Element => {
  return (
    <ContainedButton
      id={id}
      color={color}
      borderRadius="28px"
      sx={{ padding: "12px 16px", marginTop }}
      height="46px"
      disabled={disabled}
      onClick={onClick}>
      <ButtonText>{text}</ButtonText>
    </ContainedButton>
  );
};
